import Vue from "vue";
import Vuex from "vuex";
import axios from "axios";
import commons from "../commons";
import services from "../commons/api";
import utility from "../commons/utility";

function getCity(directions) {
  if (directions.indexOf(",") >= 0) {
    let city = directions.split(",");
    if (city.length > 1) {
      return city[1].trim();
    }
  } else {
    return directions;
  }
}

Vue.use(Vuex);

const state = {
  itemActive: "dashboard",
  countryDes: "MX",
  serviceProviders: [],
  loadingShippingOptions: true,
  shippingOptions: [],
  selectedShippingOption: null,
  quotingRequestBody: null,
  newShipmentRequestBody: null,
  shipments: {},
  user: {},
  guideStatus: [],
  paymentShipments: [],
  newShipmentEcommerce: null,
  marketplace: [],
  lastShipments: [],
  statusPaymentGuide: null,
  parcels: null,
};

const mutations = {
  setItemActive: (state, itemActive) => {
    state.itemActive = itemActive;
  },
  setCountryDes: (state, countryDes) => {
    state.countryDes = countryDes;
  },
  setLoadingShippingOptions: (state, isLoading) => {
    state.loadingShippingOptions = isLoading;
  },
  setQuotingRequestBody: (state, requestBody) => {
    state.quotingRequestBody = requestBody;
  },
  setServiceProviders: (state, serviceProviders) => {
    state.serviceProviders = serviceProviders;
  },
  setShippingOptions: (state, shippingOptions) => {
    state.shippingOptions = shippingOptions;
  },
  setSelectedShippingOption: (state, selectedShippingOption) => {
    state.selectedShippingOption = selectedShippingOption;
  },
  setNewShipmentRequestBody: (state, requestBody) => {
    state.newShipmentRequestBody = requestBody;
  },
  setNewShipmentEcommerce: (state, body) => {
    state.newShipmentEcommerce = body;
  },
  setPaymentShipments: (state, shipments) => {
    state.paymentShipments = shipments;
  },
  setShipments(state, shipments) {
    state.shipments = shipments;
  },
  setGuideStatus(state, guideStatus) {
    state.guideStatus = guideStatus;
  },
  setMarketplace: (state, marketplace) => {
    state.marketplace = marketplace;
  },
  setLastShipment: (state, lastShipments) => {
    state.lastShipments = lastShipments;
  },
  setStatusPaymentGuide: (state, statusPaymentGuide) => {
    state.statusPaymentGuide = statusPaymentGuide;
  },
  setParcels: (state, parcels) => {
    state.parcels = parcels;
  },
};

const actions = {
  async getStatusGuide({ commit, state }, shipments) {
    let list_status = [];
    var list_result = [];
    var array = shipments.data;
    await array.forEach(async (element) => {
      if (element.selected_service.carrier == "dhl") {
        if (element.number_guide) {
          //servicios dhl api nueva
          if (
            element.selected_service.carrier_service_name.toUpperCase() ===
              "SAMEDAY SPRINTLINE" ||
            element.selected_service.carrier_service_name.toUpperCase() ===
              "DOMESTICO ENVIO RETORNO" ||
            element.selected_service.carrier_service_name.toUpperCase() ===
              "ECONOMY SELECT DOMESTIC" ||
            element.selected_service.carrier_service_name.toUpperCase() ===
              "EXPRESS DOMESTIC FLAT"
          ) {
            let status = await axios.post(
              `${commons.apiURL}/api/v1/tracking/dhlApi`,
              { guide_number: element.number_guide }
            );
            console.log(status.data);
            let messge = utility.utility.status(status.data);
            list_status.push({
              number_guide: element.number_guide,
              messge: messge,
            });
          } else {
            let status = await axios.post(
              `${commons.apiURL}/api/v1/tracking/dhl`,
              { guide_number: element.number_guide }
            );
            let messge = utility.utility.status(status.data);
            list_status.push({
              number_guide: element.number_guide,
              messge: messge,
            });
          }
        }
      } else if (element.selected_service.carrier == "redpack") {
        if (element.number_guide) {
          let status = await axios.post(
            `${commons.apiURL}/api/v1/tracking/redpack`,
            { guide_number: element.number_guide }
          );
          let messge = utility.utility.status(status.data);
          list_status.push({
            number_guide: element.number_guide,
            messge: messge,
          });
        }
      } else if (element.selected_service.carrier == "fedex") {
        if (element.number_guide) {
          let status = await axios.post(
            `${commons.apiURL}/api/v1/tracking/fedex`,
            { guide_number: element.number_guide }
          );
          let messge = utility.utility.statusFedex(status.data);
          list_status.push({
            number_guide: element.number_guide,
            messge: messge,
          });
        }
      } else if (element.selected_service.carrier == "ampm") {
        if (element.number_guide) {
          let status = await axios.post(
            `${commons.apiURL}/api/v1/tracking/ampm`,
            { guide_number: element.number_guide }
          );
          let messge = utility.utility.status(status.data);
          list_status.push({
            number_guide: element.number_guide,
            messge: messge,
          });
        }
      } else if (element.selected_service.carrier == "Estafeta") {
        if (element.number_guide) {
          let status = await axios.post(
            `${commons.apiURL}/api/v1/tracking/estafeta`,
            { guide_number: element.number_guide }
          );
          let messge = utility.utility.status(status.data);
          list_status.push({
            number_guide: element.number_guide,
            messge: messge,
          });
        }
      }
    });
    return list_status;
  },

  quoting: ({ commit, state }) => {
    console.log("getting quotes");
    commit("setShippingOptions", []);
    commit("setLoadingShippingOptions", true);

    const requestBody = {
      origin_direction: {
        country_code: state.quotingRequestBody.origin_direction.country_code,
        postal_code: state.quotingRequestBody.origin_direction.postal_code,
        city: getCity(state.quotingRequestBody.origin_direction.city),
        suburb: state.quotingRequestBody.origin_direction.suburb,
      },
      package_type: state.quotingRequestBody.package_type,
      bandera_recoleccion: state.quotingRequestBody.bandera_recoleccion,
      bandera_ead: state.quotingRequestBody.bandera_ead,
      bandera_condicion_pago: state.quotingRequestBody.bandera_condicion_pago,
      parcels: [],
      destination_direction: {
        country_code:
          state.quotingRequestBody.destination_direction.country_code,
        postal_code: state.quotingRequestBody.destination_direction.postal_code,
        city: getCity(state.quotingRequestBody.destination_direction.city),
        suburb: state.quotingRequestBody.destination_direction.suburb,
      },
      package_insurance: state.quotingRequestBody.package_insurance,
      insurance_information: state.quotingRequestBody.insurance_information,
      cantidadGuias: state.quotingRequestBody.cantidadGuias,
      user: state.quotingRequestBody.user,
    };
    // **Duplicar parcels hasta alcanzar cantidadGuias**
    const baseParcels = state.quotingRequestBody.parcels || [];
    const cantidadGuias = Number(state.quotingRequestBody.cantidadGuias) || 1;

    // Llenar el arreglo parcels repitiendo los datos base
    while (requestBody.parcels.length < cantidadGuias) {
      requestBody.parcels.push(...baseParcels);
    }
    const prom = axios.post(`${commons.apiURL}/api/v1/quoting`, requestBody);

    prom
      .then((response) => {
        commit("setServiceProviders", response.data);
        const aux = [];

        response.data.dhlAndFedex = [];

        for (const sp in state.serviceProviders) {
          if (state.serviceProviders.hasOwnProperty(sp)) {
            aux.push(...state.serviceProviders[sp]);
          }
        }

        commit("setShippingOptions", aux);
      })
      .catch((error) => {
        console.error(error);
      })
      .finally(() => commit("setLoadingShippingOptions", false));

    return prom;
  },

  newShipment: ({ commit, state }) => {
    const prom = axios.post(
      `${commons.apiURL}/api/v1/shipments`,
      state.newShipmentRequestBody
    );
    prom
      .then((response) => {
        commit("setServiceProviders", response.data);
        const aux = [];

        for (const sp in state.serviceProviders) {
          if (state.serviceProviders.hasOwnProperty(sp)) {
            aux.push(...state.serviceProviders[sp]);
          }
        }

        // commit('setShippingOptions', aux)
      })
      .catch((error) => {
        console.error(error);
      })
      .finally(() => {
        commit("setShippingOptions", []);
      });
    return prom;
  },
  getAllShipments: ({ dispatch, commit, state }) => {
    axios
      .get(
        `${commons.apiURL}/api/v1/shipments/all/${localStorage.getItem(
          "ew-user-id"
        )}`
      )
      .then((response) => {
        commit("setShipments", response.data);
        dispatch("getStatusGuide", { data: response.data.docs }).then(
          (status) => {
            commit("setGuideStatus", status);
          }
        );
        const aux = [];
        for (const sp in state.serviceProviders) {
          if (state.serviceProviders.hasOwnProperty(sp)) {
            aux.push(...state.serviceProviders[sp]);
          }
        }

        // commit('setShippingOptions', aux)
      })
      .catch((error) => {
        console.error(error);
      });
  },
  getUser({ commit, state }) {
    if (localStorage.getItem("ew-user-id")) {
      axios
        .get(
          `${commons.apiURL}/api/v1/users/${localStorage.getItem("ew-user-id")}`
        )
        .then((response) => {
          state.user = response.data;
        })
        .catch((error) => {
          console.trace(error);
        });
    }
  },
  getShipment({ commit, state }) {
    // TODO: add shipment id
    axios
      .get(`${commons.apiURL}/api/v1/shipment/${1}`)
      .then((response) => {
        state.shipment = response.data;
      })
      .catch((error) => {
        console.error(error);
      });
  },

  getMarketplace({ commit, state }) {
    axios
      .get(
        `${commons.apiURL}/api/v1/marketplace/shipments/${localStorage.getItem(
          "ew-user-id"
        )}`
      )
      .then((response) => {
        let shipments = response.data;
        state.marketplace = shipments.data;
      })
      .catch((error) => {
        state.marketplace;
      });
  },

  getLastShipments({ commit, state }) {
    if (localStorage.getItem("ew-user-id")) {
      let user_id = localStorage.getItem("ew-user-id");
      services.shipment
        .getLastShipments(user_id)
        .then((response) => {
          if (response.data.code === 200) {
            state.lastShipments = response.data.data;
          } else {
            state.lastShipments = [];
          }
        })
        .catch((error) => {
          state.lastShipments = [];
        });
    } else {
      state.lastShipments = [];
    }
  },
  getStatusPaymentGuide({ commit, state }) {
    if (localStorage.getItem("ew-user-id")) {
      let user_id = localStorage.getItem("ew-user-id");
      services.shipment
        .getStatusGuide(user_id)
        .then((response) => {
          if (response.data.code === 200) {
            state.statusPaymentGuide = response.data.data;
          } else {
            state.statusPaymentGuide = null;
          }
        })
        .catch((error) => {
          state.statusPaymentGuide = null;
        });
    } else {
      state.statusPaymentGuide = null;
    }
  },
  getParcels({ commit, state }) {
    if (localStorage.getItem("ew-user-id")) {
      let user_id = localStorage.getItem("ew-user-id");
      services.shipment
        .getParcels(user_id)
        .then((response) => {
          console.log(response.data);
          if (response.data.code === 200) {
            state.parcels = response.data.data;
          } else {
            state.parcels = null;
          }
        })
        .catch((error) => {
          state.parcels = null;
        });
    } else {
      state.parcels = null;
    }
  },
};

const getters = {
  quotingRequestBody: (state) => state.quotingRequestBody,
  serviceProviders: (state) => state.serviceProviders,
  shippingOptions: (state) => state.shippingOptions,
  selectedShippingOption: (state) => state.selectedShippingOption,
  newShipmentRequestBody: (state) => state.newShipmentRequestBody,
  shipments: (state) => state.shipments,
  user: (state) => state.user,
  isLoadingShippingOptions: (state) => state.loadingShippingOptions,
  guideStatus: (state) => state.guideStatus,
  paymentShipments: (state) => state.paymentShipments,
  ecommerceShipment: (state) => state.newShipmentEcommerce,
  marketplace: (state) => state.marketplace,
  itemActive: (state) => state.itemActive,
  lastShipments: (state) => state.lastShipments,
  parcels: (state) => state.parcels,
  statusPaymentGuide: (state) => state.statusPaymentGuide,
  countryDes: (state) => state.countryDes,
};

export default new Vuex.Store({
  state,
  getters,
  actions,
  mutations,
});



// WEBPACK FOOTER //
// ./src/store/index.js